<script setup>
import { computed } from 'vue'

import { MODULE_TYPE_IDS } from '@/utils/custom-dashboard-helper'

import CustomDashboardOkrModule from '@/components/dashboard/custom-dashboard/modules/CustomDashboardOkrModule'
import CustomDashboardProgressModule from '@/components/dashboard/custom-dashboard/modules/CustomDashboardProgressModule'
import CustomDashboardTextModule from '@/components/dashboard/custom-dashboard/modules/CustomDashboardTextModule'

defineOptions({
  name: 'CustomDashboardModuleResolver'
})

const props = defineProps({
  module: {
    type: Object,
    required: true
  }
})

const MODULE_TYPE_MAP = {
  [MODULE_TYPE_IDS.OKR]: CustomDashboardOkrModule,
  [MODULE_TYPE_IDS.TEXT]: CustomDashboardTextModule,
  [MODULE_TYPE_IDS.KPI]: CustomDashboardProgressModule
}

const component = computed(() => {
  return MODULE_TYPE_MAP[props.module.typeId] || null
})
</script>

<template>
  <slot :component="component" />
</template>

<style lang="scss" scoped></style>
